module.exports = __webpack_public_path__ + "img/location-confirm.c79b84f3.jpg";